import { createSlice } from "@reduxjs/toolkit";

export const socialWidgetSlice = createSlice({
  name: "socialWidget",
  initialState: {
    getSocialWidgetResult: false,
    getSocialWidgetLoading: false,
    getSocialWidgetError: false,
    addSocialWidgetResult: false,
    addSocialWidgetLoading: false,
    deleteSocialWidgetResult: false,
  },
  reducers: {
    socialWidgetReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_SOCIALWIDGET":
          return {
            ...state,
            getSocialWidgetResult: payload.data,
            getSocialWidgetLoading: payload.loading,
            getSocialWidgetError: payload.error,
          };
        case "ADD_SOCIALWIDGET":
          return {
            ...state,
            addSocialWidgetResult: payload.data,
            addSocialWidgetLoading: payload.loading,
          };
        case "DELETE_SOCIALWIDGET":
          return {
            ...state,
            deleteSocialWidgetResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { socialWidgetReducers } = socialWidgetSlice.actions;

export default socialWidgetSlice.reducer;
